<template>
    <div class="detail core_waybill clear" style="overflow: hidden;">
        <div class="ui message core_waybill" v-if="core_waybill">
            <h2 class="left floated">
                {{ core_waybill.number }}
                <span style="font-size: small;"
                    v-if="core_waybill.material">
                    [{{ core_waybill.material.name }}]
                </span>
            </h2>

            <div class="actions right floated" style="margin-left: 0.25em;"
                v-if="is_show_change_template_btns && eventbus.change_current_template.name">
                <div class="ui labeled icon button"
                    @click="$bus.$emit(eventbus.change_current_template.name, 'card')">
                    <i class="icon chevron left" style="margin: 0px;"></i>
                    卡片檢視
                </div>
            </div>

            <!-- <div class="actions right floated" v-if="show_close_modal_btn">
                <div class="ui inverted red button"
                    @click="close_core_waybill_modal()">
                    X
                </div>
            </div> -->

            <button class="ui primary button right floated"
                v-if="is_can_update"
                v-bind:class="{ 'loading': eventbus.update_core_waybill.is_processing }"
                @click="active_core_waybill()">
                {{ active_button_content }}
            </button>

            <button class="ui basic red button right floated"
                v-if="is_can_update && $store.state.provider.current_staff.theme_name == 'manager'"
                v-bind:class="{ 'loading': eventbus.update_core_waybill.is_processing }"
                @click="delete_core_waybill()">
                {{ $t('ui.general.delete') }}
            </button>

            <div class="ui right floated basic vertical animated blue button"
                @click="toggle_form_type()">
                <div class="hidden content">
                    <span v-if="is_form_easy_type">
                        <i class="align left icon"></i>
                        {{ $t('ui.toolbox.core_waybill.btns.detail') }}
                    </span>
                    <span v-else>
                        <i class="wpforms icon"></i>
                        {{ $t('ui.toolbox.core_waybill.btns.simple') }}
                    </span>
                </div>
                <div class="visible content">
                    <!-- 切換表單 -->
                    {{ $t('ui.toolbox.core_waybill.btns.switch_style') }}

                </div>
            </div>

            <div class="ui right floated black basic button dropdown item" tabindex="0"
                v-if="is_can_print_label"
                v-dropdown>
                <span>
                    <!-- 展開標籤 -->
                    {{ $t('ui.toolbox.core_waybill.btns.label') }}
                </span>
                <i class="dropdown icon"></i>
                <div class="menu left" tabindex="-1"
                    style="max-height: 800px;">
                    <WaybillLabel
                        class="item"
                        :eventbus="eventbus"
                        :core_waybill="core_waybill"
                        :is_auto_print="is_auto_print"
                        :is_enable_auto_print_label="is_enable_auto_print_label"
                    />
                </div>
            </div>

            <div class="clear"></div>
            <i v-if="is_have_source_core_waybill">
                {{ $t('ui.toolbox.core_waybill.helps.source') }}：
                <span
                    class="pointer"
                    style="color:#db2828"
                    @click="show_core_wabill(core_waybill.source_core_waybill.identity)"
                >
                    <i class="warning sign icon"></i>
                    {{ core_waybill.source_core_waybill.number }}
                </span>

            </i>
        </div>

        <div class="info"
            style="position: relative;">

            <BloodRelated
                v-if="is_show_blood_related"
                :core_waybill="core_waybill"
                :active_button_to_detail_route_name="active_button_to_detail_route_name"
            />

            <Statuses
                v-if="is_show_statuses"
                :core_waybill="core_waybill"
                :statuses="statuses"
                :scope="scope"
            />

            <Partition
                v-if="is_show_partition"
                :core_waybill="core_waybill"
            />

            <div class="core_waybill_form">

                <SimpleForm
                    :core_waybill="core_waybill"
                    :eventbus="eventbus"
                    :is_show_receipt_file="is_show_receipt_file"
                />
                <DetailedForm
                    :core_waybill="core_waybill"
                    :eventbus="eventbus"
                    :is_show_receipt_file="is_show_receipt_file"
                />
            </div>

            <div class="ui dimmer pointer"
                v-if="is_have_source_core_waybill"
                :class="{
                    active: is_show_dimmer
                }"
                @click="is_show_dimmer = false">
                <div class="content">
                    <div class="center">
                        <h2 class="ui inverted icon header">
                            <i class="warning sign icon"></i>
                            {{ dimmer_message }}
                        </h2>
                    </div>
                </div>
            </div>

        </div>

    </div>
</template>

<script>
import Statuses from '@toolbox/core_waybill/detail_partials/statuses.vue'
import Partition from '@toolbox/core_waybill/detail_partials/partition.vue'
import WaybillLabel from '@toolbox/core_waybill/detail_partials/label.vue'
import BloodRelated from '@toolbox/core_waybill/detail_partials/blood_related.vue'

import DetailedForm from '@toolbox/core_waybill/detail_partials/detailed_form.vue'
import SimpleForm from '@toolbox/core_waybill/detail_partials/simple_form.vue'

import FileUploader from "@toolbox/file_uploader/main.vue"
var CanUpdateField = require('@toolbox/core_waybill/.assets/javascripts/can_update_field.js');

export default {
    components: {
        Statuses,
        SimpleForm,
        Partition,
        DetailedForm,
        WaybillLabel,
        BloodRelated,
        FileUploader,
    },
    props: {
        /*
         * Main
         */
        core_waybill: {
            default: {},
            type: Object
        },
        statuses: {
            default: () => { return [] },
            type: Array
        },
        scope: {
            default: 'provider',
            type: String
        },
        eventbus: {
            default: {
                change_current_template: {
                    name: "",
                },
                file_uploader: {
                    name: "",
                },
                update_core_waybill: {
                    name: "",
                },
                delete_core_waybill: {
                    name: "",
                },
                print_label: {
                    name: "",
                },
            },
            type: Object,
        },

        /*
         * 共用
         */
        is_have_source_core_waybill: {
            default: false,
            type: Boolean
        },
        is_enable_auto_print_label: {
            default: false,
            type: Boolean
        },
        is_auto_print: {
            default: false,
            type: Boolean
        },
        is_show_change_template_btns: {
            default: false,
            type: Boolean
        },
        is_can_print_label: {
            default: false,
            type: Boolean
        },

        is_can_update: {
            default: false,
            type: Boolean
        },
        can_update_field_names: {
            default: () => { return [] },
            type: Array
        },
        cant_update_field_names: {
            default: () => { return [] },
            type: Array
        },
        focus_field_field_name: {
            default: "",
            type: String
        },

        /*
         * template options
         */
        is_show_partition: {
            default: false,
            type: Boolean
        },
        is_show_statuses: {
            default: false,
            type: Boolean
        },
        is_show_receipt_file: {
            default: false,
            type: Boolean
        },
        is_show_blood_related: {
            default: false,
            type: Boolean
        },

        /*
         * active button options
         */
        active_button_color: {
            default: "blue",
            type: String
        },
        active_button_content: {
            default: "更新",
            type: String
        },
        active_button_channel: {
            default: "",
            type: String
        },
        active_button_to_detail_route_name: {
            default: "",
            type: String
        },
    },
    data() {
        return {
            is_initialized: false,
            is_form_easy_type: true,
            is_show_dimmer: false,
            dimmer_message: "",
        }
    },
    computed: {
        style() {
            return this.$store.state.style
        },
    },
    mounted() {
        this.init()
    },
    methods: {
        async init() {
            this.dimmer_message = ""
            if (this.core_waybill) {
                await this.form_type()
                await this.set_is_show_dimmer()
                await new Promise(resolve => {
                    this.is_initialized = true
                })
            }
        },
        set_is_show_dimmer(is_show = false) {
            this.is_show_dimmer = is_show
            if (is_show == true) return ""

            if (this.eventbus.delete_core_waybill.is_down) {
                this.is_show_dimmer = true
                this.dimmer_message = this.$t('ui.toolbox.core_waybill.helps.is_deleted')

            } else if (this.is_have_source_core_waybill) {
                this.is_show_dimmer = true
                // 當前運單資料來自於 {{ core_waybill.source_core_waybill.number }}，點擊以編輯
                this.dimmer_message = this.$t('ui.toolbox.core_waybill.helps.tooltip_have_source_core_waybill', {
                    'number': this.core_waybill.source_core_waybill.number
                })
            }
            return ""
        },
        active_core_waybill() {
            if (this.active_button_channel) {
                this.$bus.$emit(this.active_button_channel)
            }else {
                this.$bus.$emit(this.eventbus.update_core_waybill.name)
            }
        },
        delete_core_waybill() {
            if (this.core_waybill.number) {
                var material_staring = (this.core_waybill.material) ? '[' + this.core_waybill.material.name + ']' : ''
                if (confirm(
                    this.$t('ui.notifications.warning.are_you_sure_to_delete_it') + '\n' +
                    this.core_waybill.number + material_staring
                )) {
                    this.$bus.$emit(this.eventbus.delete_core_waybill.name)
                }
            }
        },
        form_type() {
            if (!this.is_form_easy_type) {
                this.form_transition()
            }

            if (this.style.width < 1200) {
                this.is_grid_table_style = true
            }

            $(window).resize(() => {
                if (this.is_grid_table_style == false && this.style.width < 1200) {
                    this.is_grid_table_style = true
                } else if(this.is_grid_table_style == true && this.style.width >= 1200) {
                    this.is_grid_table_style = false
                }
            })
        },
        toggle_form_type() {
            this.is_form_easy_type =
                !this.is_form_easy_type

            this.form_transition()
        },
        form_transition() {
            $('.ui.transition.entity_form').transition('fade right')
            $('.ui.transition.detailed_form').transition('fade left')
        },
        close_core_waybill_modal() {
        },
        show_core_wabill(identity = null) {
            try {
                if (!identity) {
                    throw "請輸入號碼"
                }
                this.$router.push({
                    name: this.active_button_to_detail_route_name,
                    params: {
                        identity: (identity) ? identity : this.core_waybill.identity
                    }
                })

            } catch (err) {
                this.$noty.error(err)

            }
        },
        /*
         * ========================================================================
         * $parent
         * ========================================================================
         */
        is_can_update_field(field_name = "") {
            return CanUpdateField(
                field_name,
                this.is_can_update,
                this.can_update_field_names,
                this.cant_update_field_names,
            )
        },
    },
}
</script>

<style lang="scss" scoped>
    .ui.modal.core_waybill {
        padding: 12px;
    }

    .detail.core_waybill {
        color: initial;
        background-color: white;
    }

    .info .active.dimmer {
        & {
            color: white;
        }
        .title {
            padding-top: 30px;
            padding-bottom: 10px;
        }
    }
</style>
